import { AbstractPopUp, AbstractPopUpParams } from './AbstractPopUp';
import { Button } from '../UI/elements/buttons/Button';
import { Inventory, OfferDetails, CurrencyName, ResourceName } from '../core/managers/Inventory';
import { SceneManager } from '../core/managers/SceneManager';
import { TextStyles } from '../utils/TextStyles';
import { PriceButton } from '../UI/elements/buttons/PriceButton';
import { createSprite, showSorryNoAd, translate } from '../utils/GameEngine';
import { CoinsCounter } from '../UI/elements/counters/CoinsCounter';
import { FBAdManager } from '../core/managers/abstract/FBAdManager';
import Text = PIXI.Text;
import Sprite = PIXI.Sprite;
import TextStyle = PIXI.TextStyle;
import { AdButton } from '../UI/elements/buttons/AdButton';
import { RewardedPlacement } from '../core/managers/abstract/AbstractAdManager';

export interface NoLivesPopUpParams extends AbstractPopUpParams {
    callback: () => any;
    chapter: number;
}

export class NoLivesPopUp extends AbstractPopUp {
    private buyButtons: Button[];
    private callback: () => any;
    private adButton: AdButton;

    protected drawLayout(params?: any): void {
        super.drawLayout(params);
        this.image.scale.set(0.7, 0.7);
        if (params.callback) {
            this.callback = params.callback;
        }
        this.drawBuyButtons();
        this.drawAdButton();
    }

    private drawBuyButtons(): void {
        const distance: number = 80;
        const offerJson: JSON = SceneManager.getInstance().getJson('offers');
        const offers: OfferDetails[] = offerJson[ResourceName.Lives].offers;

        offers.forEach((offerDetails: OfferDetails, index: number): void => {
            const labelStyle: TextStyle = TextStyles.buttonLabel.clone();
            labelStyle.fontSize = '32px';
            const label: Text = new PIXI.Text(offerDetails.amount + ' X', labelStyle);
            this.background.addChild(label);
            label.anchor.set(0, 0.5);
            label.position.set(this.textBox.x + 32, this.text.y + this.text.height / 2 + 60 + distance * index);

            const icon: Sprite = createSprite('heart_icon@2x', this.background);
            icon.anchor.set(0.5, 0.5);
            icon.position.set(label.x + label.width + 28, label.y + 4);

            const buyFunction: () => void = (): void => {
                Inventory.getInstance().buyResource(ResourceName.Lives, index, (this.params as NoLivesPopUpParams).chapter);
                if (this.callback) {
                    this.callback();
                    this.hide();
                }
            };
            const currentCoins: number = Inventory.getInstance().getAmount(CurrencyName.Coins);
            const notEnoughCoins: boolean = currentCoins < offerDetails.price;
            const buyButton: PriceButton = new PriceButton(buyFunction.bind(this), offerDetails.price, this, notEnoughCoins);
            buyButton.position.set(this.textBox.x + this.textBox.width * 0.66, label.y);
            if (!this.buyButtons) {
                this.buyButtons = [];
            }
            this.buyButtons.push(buyButton);
        });

        const coinsCounter: CoinsCounter = new CoinsCounter(this);
        coinsCounter.x = 217;
        coinsCounter.y = 70;
    }

    private drawAdButton(): void {
        this.adButton = new AdButton(this.watchAdForLife.bind(this), translate('+1 life', true) + '!');
        this.addChild(this.adButton);
        this.adButton.position.set(390, 460);
    }

    private watchAdForLife(): void {
        FBAdManager.getInstance().showRewardedAd(
            this.onAdSuccess.bind(this),
            this.onAdFail.bind(this),
            RewardedPlacement.no_lives,
            this.onAdLoading.bind(this)
        );
    }

    private onAdSuccess(): void {
        Inventory.getInstance().addAmount(ResourceName.Lives, 1);
        this.hide();
        if (this.callback) {
            this.callback();
        }
    }

    private onAdFail(error: any): void {
        this.adButton.enable();
        if (error.code !== 'USER_INPUT') {
            showSorryNoAd();
        }
    }

    private onAdLoading(): void {
        // this.adButton.onLoading();
    }

    public show(): void {
        super.show();
        const currentLives: number = Inventory.getInstance().getAmount(ResourceName.Lives);
        if (currentLives > 0) {
            this.hide(true);
            (this.params as NoLivesPopUpParams).callback();
        }
    }

    public hide(quick: boolean = false): void {
        super.hide(quick);
        this.buyButtons.forEach((button: Button) => {
            button.interactive = false;
        });
    }
}